import { render } from "./InputWeightMeasurement.vue?vue&type=template&id=482e524f"
const script = {}
script.render = render

export default script